<div class="flex flex-col w-full">

    <!-- Header -->
    <div class="flex items-center justify-between" style="padding: 18px 24px; border-bottom: 1px solid #e5e2ee;">
        <h2 class="orange-text font-extrabold text-2xl uppercase">{{ title }}</h2>
        <button
            type="button"
            (click)="close()"
            aria-label="Close"
            class="flex items-center justify-center"
            style="width: 36px; height: 36px; border-radius: 8px; background: #E1742E; color: #fff; cursor: pointer;">
            <iconify-icon icon="mynaui:letter-x-solid" height="24"></iconify-icon>
        </button>
    </div>

    <!-- Body -->
    <div [formGroup]="form" style="padding: 20px 24px 24px;">
        <div class="grid grid-cols-3 gap-x-5 gap-y-4">

            <!-- Code -->
            <div class="flex flex-col" style="gap: 6px;">
                <label style="font-size: 12px; font-weight: 700; color: #222;">
                    Code <span style="color: #d93025;">*</span>
                </label>
                <input
                    type="text"
                    placeholder="Code"
                    [style.border-color]="borderColor('code')"
                    formControlName="code"
                    class="w-full placeholder-gray-500"
                    style="height: 38px; padding: 0 12px; font-size: 11px; font-style: italic; background: #FBFAFF; border: 1px solid #5F4D9C; border-radius: 8px; outline: none;">
            </div>

            <!-- Name -->
            <div class="flex flex-col" style="gap: 6px;">
                <label style="font-size: 12px; font-weight: 700; color: #222;">
                    Name <span style="color: #d93025;">*</span>
                </label>
                <input
                    type="text"
                    placeholder="Name"
                    formControlName="name"
                    [style.border-color]="borderColor('name')"
                    class="w-full placeholder-gray-500"
                    style="height: 38px; padding: 0 12px; font-size: 11px; font-style: italic; background: #FBFAFF; border: 1px solid #5F4D9C; border-radius: 8px; outline: none;">
            </div>

            <!-- Institution Type -->
            <div class="flex flex-col" style="gap: 6px;">
                <label style="font-size: 12px; font-weight: 700; color: #222;">
                    Institution Type <span style="color: #d93025;">*</span>
                </label>
                <app-custom-dropdown-v2
                    label=""
                    labelWidth="0px"
                    [options]="institutionTypeOptions"
                    [selectedText]="institutionType_text"
                    [hasError]="isInvalid('institutionType')"
                    placeholder="Select an Option"
                    (selectionChange)="setInstitutionType($event.label, $event.value)">
                </app-custom-dropdown-v2>
            </div>

            <!-- Service Fee Percentage -->
            <div class="flex flex-col" style="gap: 6px;">
                <label style="font-size: 12px; font-weight: 700; color: #222;">
                    Service Fee Percentage <span style="font-weight: 400; color: #888;">(Optional)</span>
                </label>
                <input
                    type="number"
                    placeholder="Service Fee Percentage"
                    [style.border-color]="borderColor('serviceFeePercentage')"
                    appOnlyNumber
                    [allowDecimal]="true"
                    formControlName="serviceFeePercentage"
                    class="w-full placeholder-gray-500"
                    style="height: 38px; padding: 0 12px; font-size: 11px; font-style: italic; background: #FBFAFF; border: 1px solid #5F4D9C; border-radius: 8px; outline: none;">
            </div>

            <!-- Service Fee Fixed -->
            <div class="flex flex-col" style="gap: 6px;">
                <label style="font-size: 12px; font-weight: 700; color: #222;">
                    Service Fee Fixed <span style="font-weight: 400; color: #888;">(Optional)</span>
                </label>
                <input
                    type="number"
                    placeholder="Service Fee Fixed"
                    [style.border-color]="borderColor('serviceFeeFixed')"
                    appOnlyNumber
                    [allowDecimal]="true"
                    formControlName="serviceFeeFixed"
                    class="w-full placeholder-gray-500"
                    style="height: 38px; padding: 0 12px; font-size: 11px; font-style: italic; background: #FBFAFF; border: 1px solid #5F4D9C; border-radius: 8px; outline: none;">
            </div>

            <!-- Convenience Fee -->
            <div class="flex flex-col" style="gap: 6px;">
                <label style="font-size: 12px; font-weight: 700; color: #222;">
                    Convenience Fee <span style="font-weight: 400; color: #888;">(Optional)</span>
                </label>
                <input
                    type="number"
                    placeholder="Convenience Fee"
                    [style.border-color]="borderColor('convenienceFee')"
                    appOnlyNumber
                    [allowDecimal]="true"
                    formControlName="convenienceFee"
                    class="w-full placeholder-gray-500"
                    style="height: 38px; padding: 0 12px; font-size: 11px; font-style: italic; background: #FBFAFF; border: 1px solid #5F4D9C; border-radius: 8px; outline: none;">
            </div>

        </div>

        <!-- Image upload (empty / filled states) -->
        <div
            class="mt-5 flex items-center justify-between"
            [style.border-color]="imageBorderColor"
            style="gap: 16px; padding: 16px 20px; background: #faf9ff; border: 1.5px dashed #5F4D9C; border-radius: 10px;">

            <div class="flex items-center gap-3 min-w-0">
                <div
                    class="flex items-center justify-center"
                    style="flex-shrink: 0; width: 44px; height: 44px; border-radius: 8px; background: #5F4D9C; color: #fff;">
                    <iconify-icon icon="hugeicons:image-upload" height="28"></iconify-icon>
                </div>
                <div class="flex flex-col min-w-0">
                    <span class="truncate" style="font-size: 13px; font-weight: 700; color: #222;">
                        {{ hasImage ? imageLabel : 'No File Selected' }}<span style="color: #d93025;">*</span>
                    </span>
                    <span style="font-size: 10px; color: #777;">
                        Accepted formats: PNG, JPG | Max size: 5 MB | Max dimensions: 500 x 500 px
                    </span>
                </div>
            </div>

            <button
                type="button"
                (click)="openFilePicker()"
                class="hover:bg-gray-100"
                style="flex-shrink: 0; padding: 8px 18px; font-size: 12px; font-weight: 700; color: #5F4D9C; background: #fff; border: 1.5px solid #5F4D9C; border-radius: 6px; cursor: pointer;">
                {{ hasImage ? 'Replace Image' : 'Browse Files' }}
            </button>

            <input #fileInput type="file" class="hidden" accept="image/png,image/jpeg" (change)="onFileSelected($event)">
        </div>

        <!-- Actions -->
        <div class="flex items-center justify-center gap-4 mt-6">
            <button
                type="button"
                (click)="close()"
                class="hover:bg-gray-100"
                style="padding: 8px 28px; font-size: 14px; font-weight: 600; color: #E1742E; background: #fff; border: 1.5px solid #E1742E; border-radius: 6px; cursor: pointer;">
                CANCEL
            </button>
            <button
                type="button"
                (click)="submit()"
                class="custom-btn btn-dark-orange font-semibold text-sm px-8 py-2 uppercase">
                SUBMIT
            </button>
        </div>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>